// extracted by mini-css-extract-plugin
export var acitonButtons = "_2e-0";
export var additionalIcon = "_2e-f";
export var block = "_2e-1";
export var blockContent = "_2e-7";
export var blockDescription = "_2e-8";
export var blockIcon = "_2e-9";
export var blockTitle = "_2e-6";
export var border = "_2e-a";
export var center = "_2e-l";
export var edge = "_2e-b";
export var edgeLabel = "_2e-c";
export var edgePath = "_2e-d";
export var error = "_2e-e";
export var flowchart = "_2e-g";
export var flowchartContent = "_2e-h";
export var highlighted = "_2e-3";
export var hover = "_2e-4";
export var icon = "_2e-i";
export var left = "_2e-m";
export var navButton = "_2e-j";
export var navButtons = "_2e-k";
export var right = "_2e-n";
export var selected = "_2e-2";
export var small = "_2e-5";